import { render, staticRenderFns } from "./commonVue.vue?vue&type=template&id=09ae2278&scoped=true"
import script from "./commonVue.vue?vue&type=script&lang=js"
export * from "./commonVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae2278",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ae2278')) {
      api.createRecord('09ae2278', component.options)
    } else {
      api.reload('09ae2278', component.options)
    }
    module.hot.accept("./commonVue.vue?vue&type=template&id=09ae2278&scoped=true", function () {
      api.rerender('09ae2278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/commonVue.vue"
export default component.exports